document.addEventListener('DOMContentLoaded', (event) => {
  const dialog = document.querySelector('#subscription-dialog');
  const showButton = document.querySelector('#nav-subscription-button');
  const closeButton = document.querySelector('#close-subscription-dialog-button');

  showButton.addEventListener('click', () => {
    dialog.showModal();
  });

  closeButton.addEventListener('click', () => {
    dialog.close();
  });
});

let navbar = document.getElementById("navbar");
let main = document.querySelector("main");
let nav = {
  state: "fixed", // fixed, scrolling, hidden
  previousPosition: window.scrollY,
  height: navbar.clientHeight,
  reference: {
    min: 0,
    max: navbar.clientHeight,
  }
}
let pageHeight = document.body.offsetHeight - window.innerHeight;

// Requirements
// The navbar started as on a fixed state
// once the user scrolls down, the navbar should change to a scrolling state
// during the scrolling state, the navbar scroll with the page
// at one point, when the user scrolls down until the navbar is not visible, the navbar should be in hidden state
// however, if the user scrolls up, the navbar should be in scrolling state again

const classForOffset = ["mt-[99px]", "md:mt-[112px]"];

renderNavbarStyle = () => {
  if (nav.state === "fixed") {
    navbar.style.position = "fixed";
    navbar.style.top = 0;
    main.classList.add(...classForOffset)
  } else if (nav.state === "scrolling") {
    navbar.style.position = "relative";
    navbar.style.top = nav.reference.min + "px";
    main.classList.remove(...classForOffset)
  } else if (nav.state === "hidden") {
    navbar.style.position = "fixed";
    navbar.style.top = -nav.height + "px";
    main.classList.add(...classForOffset)
  }
}

window.onscroll = function () {
  let currentPosition = window.scrollY;

  if (currentPosition < 0) {
    navbar.state = "scroll";
    return;
  }

  if (currentPosition > pageHeight) {
    navbar.state = "hidden";
    return;
  }

  if (currentPosition >= nav.reference.min && currentPosition <= nav.reference.max) {
    nav.state = "scrolling";
  }

  if (currentPosition > nav.reference.max) {
    nav.state = "hidden";

    if (currentPosition < nav.previousPosition) {
      nav.state = "scrolling";
      nav.reference = {
        max: currentPosition,
        min: currentPosition - nav.height
      }
    }
  }

  if (currentPosition < nav.reference.min) {
    nav.state = "fixed";
    nav.reference = {
      max: currentPosition + nav.height,
      min: currentPosition
    }
  }

  nav.previousPosition = currentPosition;

  renderNavbarStyle();
};